import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import PropTypes from 'prop-types';
import { Divider as MuiDivider } from '@mui/material';
import useStyles from './Divider.styles';
var Divider = function Divider(props) {
  var className = props.className,
    other = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/React.createElement(MuiDivider, _extends({
    className: cx(classes.root, className)
  }, other));
};
process.env.NODE_ENV !== "production" ? Divider.propTypes = {
  absolute: PropTypes.bool,
  component: PropTypes.string,
  flexItem: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
Divider.defaultProps = {
  orientation: 'horizontal',
  variant: 'fullWidth'
};
export default Divider;